export default __webpack_public_path__ + "static/media/arrow_copy.5a90b52a.svg";